// Module
var code = "<svg width=\"16\" height=\"16\" viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"> <path d=\"M11.75 4.75L15.25 8L11.75 11.25M4.25 4.75L0.75 8L4.25 11.25M6.75 14.25L9.25 1.75\" stroke=\"#878782\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/> </svg> ";
// Exports
module.exports = code;